/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AuthenticateContactResultEnum = 'Ok' | 'ActivationRequired' | 'InvalidLogin' | 'Locked' | 'LastAttempt' | 'SSONotFound' | 'RedirectNeeded' | 'ExternalUserHasNoPermissions' | 'MultipleTymes4Accounts' | 'LoginByBusinessUser';

export const AuthenticateContactResultEnum = {
    Ok: 'Ok' as AuthenticateContactResultEnum,
    ActivationRequired: 'ActivationRequired' as AuthenticateContactResultEnum,
    InvalidLogin: 'InvalidLogin' as AuthenticateContactResultEnum,
    Locked: 'Locked' as AuthenticateContactResultEnum,
    LastAttempt: 'LastAttempt' as AuthenticateContactResultEnum,
    SSONotFound: 'SSONotFound' as AuthenticateContactResultEnum,
    RedirectNeeded: 'RedirectNeeded' as AuthenticateContactResultEnum,
    ExternalUserHasNoPermissions: 'ExternalUserHasNoPermissions' as AuthenticateContactResultEnum,
    MultipleTymes4Accounts: 'MultipleTymes4Accounts' as AuthenticateContactResultEnum,
    LoginByBusinessUser: 'LoginByBusinessUser' as AuthenticateContactResultEnum
};

